import { render, staticRenderFns } from "./gift_list.vue?vue&type=template&id=2d413d19&scoped=true"
import script from "./gift_list.vue?vue&type=script&lang=js"
export * from "./gift_list.vue?vue&type=script&lang=js"
import style0 from "./gift_list.vue?vue&type=style&index=0&id=2d413d19&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d413d19",
  null
  
)

export default component.exports